import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery, useMutation } from '@apollo/client';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { patientPageWidth } from '../../constant';

import {
    Header,
    NotificationCard,
    ConfirmDialog,
    Progress,
    NoInformation,
    Text,
} from '../../components/index';

import socket from '../../socket';

import {
    GET_NOTIFICATION,
    UPDATE_NOTIFICATION_ISREAD,
    deleteAllNotification,
    deleteNotification,
} from '../../services/index';

import { alertError, alertSuccess } from '../../redux/stateActions';

const Notification = ({ history }) => {
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [noticeData, setNoticeData] = useState([]);
    const user = useSelector((state) => state.user);
    const dispatch = useDispatch();

    //Get notification for patient
    const { data, error, loading, refetch } = useQuery(GET_NOTIFICATION, {
        variables: { id: user.patient.id },
        skip: _.isEmpty(user),
    });

    useEffect(() => {
        if (error) {
            dispatch(alertError(`Cannot get notifications`));
        }
        if (data) {
            setNoticeData(data.notifications);
        }
    }, [error, data]);

    /*----- Delete Notifications -----*/
    const [selectedNoti, setSelectdNoti] = useState(null);
    const [openConfirm, setOpenConfirm] = useState(false);

    const handleDelete = (id) => {
        setSelectdNoti(id);
        setOpenConfirm(true);
    };

    const handleCancelDelete = () => {
        setSelectdNoti(null);
        setOpenConfirm(false);
    };

    const handleDeleteNotification = async () => {
        const newNoticeData = JSON.parse(JSON.stringify(noticeData));
        const filterNotice = newNoticeData.filter((noti) => noti.id !== selectedNoti);
        setNoticeData(filterNotice);
        setOpenConfirm(false);

        try {
            const res = await deleteNotification(selectedNoti);

            if (res.status === 200) {
                refetch();
            } else {
                throw new Error(res);
            }
        } catch (error) {
            dispatch(alertError(`${JSON.stringify(error.response?.data?.message)}`));
        }

        setSelectdNoti(null);
    };

    /*----- Delete All Notifications -----*/
    const [openConfirmAll, setOpenConfirmAll] = useState(false);

    const handleDeleteAllNotification = async () => {
        setDeleteLoading(true);
        setOpenConfirmAll(false);

        try {
            const res = await deleteAllNotification(user.patient.id);

            if (res.status === 200) {
                setDeleteLoading(false);
                dispatch(alertSuccess(`Delete notification Success`));
                refetch();
            } else {
                throw new Error(res);
            }
        } catch (error) {
            setDeleteLoading(false);
            dispatch(alertError(`${JSON.stringify(error.response?.data?.message)}`));
        }
    };

    //Handle update on Read notificstion
    const [
        updateNotificationRead,
        { data: updateNotificationData, error: updateNotificationError },
    ] = useMutation(UPDATE_NOTIFICATION_ISREAD);

    useEffect(() => {
        if (updateNotificationError) {
            dispatch(
                alertError(`Cannot upate notification to Read: ${updateNotificationError.message}`)
            );
        }
        if (updateNotificationData) {
            refetch();
        }
    }, [updateNotificationData, updateNotificationError]);

    const updateUserRead = (noti) => {
        if (!noti.isRead) {
            updateNotificationRead({ variables: { id: noti.id } });
        }
    };

    useEffect(() => {
        socket.on('newNotification', () => {
            refetch();
        });
    }, []);

    const handleDetail = (data) => {
        switch (data.type) {
            case 'SESSION_ENDED':
                return history.push(`/summary/${data.session.id}`);
            case 'READY_TO_CHECK_IN':
                return history.push(`/appointment/${data.session.meet.type}/${data.session.id}`);
            case 'WELCOME':
                return history.push(`/profile`);
        }
    };

    return (
        <div
            style={{
                padding: '0 15px 20px',
                width: '100%',
                maxWidth: patientPageWidth,
            }}
        >
            <ConfirmDialog
                id="confirm-delete-notification"
                description="modal-for-delete-notification"
                open={openConfirm}
                title="Delete ?"
                contentText="Once you delete messages. You can’t undo it. 
                Are you sure you want to continue ?"
                onCancel={handleCancelDelete}
                cancelText="Cancel"
                onConfirm={handleDeleteNotification}
                confirmText="Confirm"
                confirmBackgroundColor="pink"
            />
            <ConfirmDialog
                id="confirm-delete-all-notification"
                description="modal-for-delete-all-notification"
                open={openConfirmAll}
                title="Delete all ?"
                contentText="Once you delete all messages. You can’t undo it. 
                Are you sure you want to continue ?"
                onCancel={() => setOpenConfirmAll(false)}
                cancelText="Cancel"
                onConfirm={handleDeleteAllNotification}
                confirmText="Confirm"
                confirmBackgroundColor="pink"
            />
            {(loading || deleteLoading) && <Progress />}
            <Header
                showGoBack1
                onClickGoBack={() => {
                    history.goBack();
                }}
                onDelete={() => setOpenConfirmAll(true)}
                disabledDelete={_.isEmpty(noticeData)}
                childrenContainerStyle={{ textAlign: 'center' }}
            >
                <Text $bold>Notification</Text>
            </Header>
            {!_.isEmpty(noticeData) ? (
                noticeData.map((data, index) => (
                    <div key={`notification-${index}`} style={{ marginTop: '10px' }}>
                        <NotificationCard
                            role="patient"
                            data={data}
                            readNotification={updateUserRead}
                            onDetail={handleDetail}
                            onDelete={handleDelete}
                        />
                    </div>
                ))
            ) : (
                <NoInformation />
            )}
        </div>
    );
};

Notification.propTypes = {
    history: PropTypes.object,
};

export default Notification;
